import { render, staticRenderFns } from "./DialogAlterarDados.vue?vue&type=template&id=b476e03a&scoped=true&"
import script from "./DialogAlterarDados.vue?vue&type=script&lang=js&"
export * from "./DialogAlterarDados.vue?vue&type=script&lang=js&"
import style0 from "./DialogAlterarDados.vue?vue&type=style&index=0&id=b476e03a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b476e03a",
  null
  
)

export default component.exports